import {Subject} from 'rxjs';

export namespace RxSubjects {
    export const searchText$ = new Subject<string>();

    export const notesSearchText$ = new Subject<string>();

    export const attachmentSearchText$ = new Subject<void>();

    export const photosSearchText$ = new Subject<boolean>();
}
